import { FC, ReactNode } from "react";

const Highlight: FC<{
  children: ReactNode;
  size?: "sm" | "md" | "lg" | "xl";
}> = ({ children, size }) => (
  <span className={`text-gbci-accent font-bold text-${size || "base"}`}>
    {children}
  </span>
);

export default Highlight;
